import { CrudService, EntityProps } from '@awp/shared/CrudService';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import React from 'react';

export class AvalancheAreasService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Avalanche Area';
    const entityPluralName = 'Avalanche Areas';
    super({ entityName, entityPluralName, mode });
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: EntityProps): any {
    const { entity, values, ...rest } = props;

    return {
      ...entity,
      name: values.name,
      isDisabled: !values.active,
      code: values.code,
      parentId: values.program.value,
      Name: values.name,
      Code: values.code,
      IsActive: values.active ?? true,
      ParentGeographicAreaId: values.program.value,
    };
  }

  mapInitialValues(props: EntityProps): any {
    const { entity, ...rest } = props;

    let active = false;
    if (isValueEmpty(entity.active)) {
      active = isValueEmpty(entity.isDisabled) ? false : !entity.isDisabled;
    } else {
      active = entity.active;
    }

    return {
      program: entity.program,
      name: entity.name ?? '',
      code: entity.code ?? '',
      active,
    };
  }
}
